import { HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { AuthAppService } from 'avn/modules/services/auth-app/auth-app.service';
import { Constants } from 'avn/modules/services/constants';
// import { JWTAuthInterceptor } from 'avn/modules/services/interceptors/jwt-auth-interceptor';
import { StoreService } from 'avn/modules/services/store.service';
import { BusinessProviderServices } from 'avn/modules/shared/interfaces/homepage';
import moment from 'moment';
import { BehaviorSubject, Observable, Subject, catchError, throwError } from 'rxjs';

const BASE_URL = Constants.BASE_URL;

@Injectable()
export class BusinessMainService {
  public changeRouteForcefully = new Subject<string>();
  public formEditted = new BehaviorSubject(false);
  private readonly errorHandler: ErrorHandler;

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly store: StoreService,
    private readonly injector: Injector,
    private readonly auth: AuthAppService
  ) {
    this.errorHandler = this.injector.get(ErrorHandler);
  }

  public getSelectedBusinessDetails(uuid: string): Observable<any> {
    const endPoint = `/get-business-details/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getAboutBusinessDetail(uuid: string): Observable<any> {
    const endPoint = `/get-about-business-details/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public updateBusinessDetails(data: any): Observable<any> {
    const endPoint = '/update-business-details/' + String(data.id) + '/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public getDashboardInsights(uuid: string, data: any): Observable<any> {
    const endPoint = `/business-dashboard-insights/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, data);
  }

  public createBusinessPhoto(data: any, businessId: string): Observable<any> {
    const endPoint = '/add-business-image/' + businessId + '/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public createBusinessLogo(data: any, businessId: string): Observable<any> {
    const endPoint = '/create-update-business-logo/' + businessId + '/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public removeBusinessLogo(businessId: string): Observable<any> {
    const endPoint = '/remove-business-logo/' + businessId + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public removegalleryImage(id: string): Observable<any> {
    const endPoint = `/remove-business-image/${id}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getBusinessOpeningHours(businessId: string): Observable<any> {
    const endPoint = `/get-scheduling-appointment/${businessId}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getCalendarData(businessUuid: string): Observable<any> {
    const endPoint = `/get-business-calendar-practitioner/${businessUuid}/?v=${this.store.getRandomNumber(true)}/`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public getBusinessCalendar(practitionerUuid: string): Observable<any> {
    const endPoint = `/get-business-calendar/${practitionerUuid}/?v=${this.store.getRandomNumber(true)}/`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public deleteBusinessCalendar(uuid: string): Observable<any> {
    const endPoint = `/delete-business-calendar/${uuid}/?v=${this.store.getRandomNumber(true)}/`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public addBusinessCalendar(data: any): Observable<any> {
    const endPoint = '/add-business-calendar/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public updateCalendarInfo(data: any): Observable<any> {
    const endPoint = '/update-calendar-info/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public syncBookingSystem(uuid: string): Observable<any> {
    const endPoint = '/sync-external-calendar-business/' + uuid + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public updateBusinessCalendar(practitionerUuid: string, data: any): Observable<any> {
    const endPoint = '/update-business-calendar/' + practitionerUuid + '/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public enableDisablePayAtVenue(data: any): Observable<any> {
    const endPoint = '/enable-disable-pay-at-venue/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public updateSchedulingInformation(data: any, uuid: string): Observable<any> {
    const endPoint = `/update-scheduling-appointment/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public addService(providerServices: BusinessProviderServices): Observable<any> {
    const endPoint = '/create-update-business-appointments/';
    return this.httpClient.post(BASE_URL + endPoint, providerServices).pipe(catchError(this.handleError.bind(this)));
  }

  public updateService(uuid: string, params: any): Observable<any> {
    const endPoint = `/update-business-service/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, params).pipe(catchError(this.handleError.bind(this)));
  }

  public deleteService(serviceId: string): Observable<any> {
    const endPoint = '/remove-business-service/' + serviceId + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public deleteClass(serviceId: string): Observable<any> {
    const endPoint = '/remove-business-class/' + serviceId + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public serviceStatusChange(data: any): Observable<any> {
    const endPoint = `/update-business-service-status/${String(data['id'])}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public updateBusinessSettings(uuid: string, data: any): Observable<any> {
    const endPoint = `/update-business-settings/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public updateRadiusSuburb(data: any): Observable<any> {
    const endPoint = '/update-service-suburb-radius/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public enableDisableOnlineMobileServices(data: any): Observable<any> {
    const endPoint = '/enable-disable-online-service/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public updateRadiusOnlineSuburb(data: any): Observable<any> {
    const endPoint = '/update-service-software-link/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public removeServiceImage(uuid: string): Observable<any> {
    const endPoint = '/remove-service-image/' + uuid + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public removeClassImage(uuid: any): Observable<any> {
    const endPoint = '/remove-class-image/' + String(uuid) + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public createClass(data: any): Observable<any> {
    const endPoint = '/create-update-booking-class/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public updateClass(uuid: string, data: any): Observable<any> {
    const endPoint = `/update-business-booking-class/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public addPractitioner(data: any): Observable<any> {
    data.practitioner_gender = data.practitioner_gender === 'Rather not say' ? 'None' : data.practitioner_gender;
    const endPoint = '/create-update-business-practitioner/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public updatePractitioner(uuid: string, data: any): Observable<any> {
    const endPoint = `/update-business-practitioner/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public updatePractitionerHolidaysList(uuid: string, data: any): Observable<any> {
    const endPoint = `/update-practitioner-holidays-list/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public updatePractitionerOverrideSchedule(uuid: string, data: any): Observable<any> {
    const endPoint = `/update-practitioner-override-schedule/${uuid}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public pracStatusChange(data: any): Observable<any> {
    const endPoint = `/update-business-practitioner-status/${String(data['id'])}/`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public deletePrac(serviceId: any): Observable<any> {
    const endPoint = '/remove-business-practitioner/' + String(serviceId) + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public removePracImage(serviceId: any): Observable<any> {
    const endPoint = '/remove-practitioner-image/' + String(serviceId) + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public getListOfAllBookings(uuid: any, size: any, page: any, sort: any, search?: any): Observable<any> {
    let endPoint = `/business-bookings/${String(uuid)}/?page_size=${String(size)}&page=${String(
      page
    )}&v=${this.store.getRandomNumber(true)}`;
    if (sort?.by) {
      endPoint += `&order_by=${sort.name === 'desc' ? '-' : ''}${String(sort.by)}`;
    }
    if (search) {
      endPoint += `&qf=${String(search)}`;
    }
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public getListOfBookings(
    bookingDate: any,
    uuid: any,
    size: any,
    page: any,
    sort: any,
    search?: any
  ): Observable<any> {
    let endPoint = `/business-bookings/${String(uuid)}/?date=${String(bookingDate)}&page_size=${String(
      size
    )}&page=${String(page)}&v=${this.store.getRandomNumber(true)}`;
    if (sort?.by) {
      endPoint += `&order_by=${sort.name === 'desc' ? '-' : ''}${String(sort.by)}`;
    }
    if (search) {
      endPoint += `&qf=${String(search)}`;
    }
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public changeApptStatus(data: any, id: any): Observable<any> {
    const endPoint = '/change-appointment-status/' + String(id) + '/';
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public getAllBusinessAppointments(uuid: string, params?: any): Observable<any> {
    let endPoint = `/get-business-appointments/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    if (params) {
      endPoint += `&page_size=${String(params.pageCount)}&page=${String(params.currentPage)}`;
    }
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getAllBusinessClasses(uuid: string, params?: any): Observable<any> {
    let endPoint = `/get-business-classes/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    if (params) {
      endPoint += `&page_size=${String(params.pageCount)}&page=${String(
        params.currentPage
      )}&current_time=${moment().format('YYYY-MM-DD hh:mm A')}`;
    }
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getAllBusinessPractitioners(uuid: string, params?: any): Observable<any> {
    let endPoint = `/get-business-practitioners/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    if (params) {
      endPoint += `&page_size=${String(params.pageCount)}&page=${String(params.currentPage)}`;
    }
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getBusinessPractitionerDetail(uuid: string): Observable<any> {
    const endPoint = `/get-business-practitioner-detail/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getServiceDetail(id: string): Observable<any> {
    const endPoint = `/get-business-appointment-detail/${id}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getClassDetail(id: string): Observable<any> {
    const endPoint = `/get-business-class-detail/${id}/?v=${this.store.getRandomNumber(
      true
    )}&current_time=${moment().format('YYYY-MM-DD hh:mm A')}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public updateServiceDetail(data: any, id: string): Observable<any> {
    const endPoint = `/update-service-detail/${id}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public validateBusinessABN(data: any, uuid: string): Observable<any> {
    const endPoint = `/validate-business-abn/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }
  public abnLookupBusinessName(data: any): Observable<any> {
    const endPoint = `/abn-lookup-business-name/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.post(BASE_URL + endPoint, data).pipe(catchError(this.handleError.bind(this)));
  }

  public getQualifications(): Observable<any> {
    const endPoint = '/fetch-qualifications/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getProfessions(): Observable<any> {
    const endPoint = '/fetch-professions/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getLanguages(): Observable<any> {
    const endPoint = '/fetch-languages/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getHolidaysList(uuid: string): Observable<any> {
    let endPoint = '';
    if (uuid) {
      endPoint += `/get-practitioner-holidays-list/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    } else {
      endPoint += `/get-avaana-holidays-list/?v=${this.store.getRandomNumber(true)}`;
    }
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getOverrideSchedule(uuid: string): Observable<any> {
    const endPoint = `/get-practitioner-override-schedule/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public getInsurances(): Observable<any> {
    const endPoint = '/fetch-insurances/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public getCategories(): Observable<any> {
    const endPoint = '/fetch-categories/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }
  public getSpecializations(): Observable<any> {
    const endPoint = '/fetch-specializations/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public getBusinessBlockTimes(uuid: string): Observable<any> {
    const endPoint = `/business-block-times/${uuid}/?v=${this.store.getRandomNumber(true)}`;
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  public syncSpecificBusiness(uuid: string): Observable<any> {
    const endPoint = '/sync-specific-business/' + uuid + '/';
    return this.httpClient.get(BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  private handleError(error: any): Observable<never> {
    // Call the global error handler
    this.errorHandler.handleError(error);

    // Re-throw the error so it can be caught by the component's subscribe error handler
    return throwError(() => error);
  }
}
